
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const SchoolTiming = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>School Timings</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Academics</li>
                    <li>|</li>
                    <li>School Timings</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="timing_blk">
                                <h3>School Hours</h3>
                                <p><b>Summer:</b> 07:20 AM to 01:30 PM</p>
                                <p><b>Winter:</b> 08:20 AM to 02:30 PM</p>
                            </div>
                            <div className="timing_blk">
                                <h3>Kindergarten</h3>
                                <p><b>Summer:</b> 08:30 AM to 12:10 PM</p>
                                <p><b>Winter:</b> 09:30 AM to 01:10 PM</p>
                            </div>
                            <div className="timing_blk">
                                <h3>Accessibility to the Principal</h3>
                                <p><b>Summer:</b> 09:00 AM to 11:00 AM</p>
                                <p><b>Winter:</b> 10:00 AM to 12:00 AM</p>
                            </div>
                            <div className="timing_blk">
                                <h3>General Office</h3>
                                <p><b>Summer:</b> 08:30 AM to 01:30 PM</p>
                                <p><b>Winter:</b> 09:30 AM to 02:00 PM</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/timing.jpg" alt="St francis school, amritsar" className="img-fluid" /></LazyLoad>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SchoolTiming
